import React from 'react';

import { makeStyles, Card, CardContent, CardActions, Typography } from '@material-ui/core';

import PropTypes from 'prop-types';
import useDimensions from 'react-use-dimensions';
import { AccessTime } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  cardHover: {
    margin: 2,
  },
  cardContent: {
    padding: '8px 20px',
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    paddingTop: 0,
    paddingBottom: 4,
  },
  cardTitle: {
    marginTop: '0',
    marginBottom: '5px',
  },
  cardCategory: {
    marginBottom: 2,
    color: '#999999',
  },
  cardStats: {
    lineHeight: '22px',
    color: '#999999',
    fontSize: '12px',
    display: 'inline-block',
    margin: '0!important',
    paddingTop: 5,
  },
  cardStatsIcon: {
    position: 'relative',
    top: '4px',
    width: '16px',
    height: '16px',
  },
  fieldSelected: {
    border: 'solid',
    borderColor: theme.palette.link,
    borderWidth: 2,
  },
}));

const FieldCard = (props) => {
  const { getFieldDevices, statIconColor, selected, field, onlineSensors, lastUpdateTime, selectField } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const [cardRef] = useDimensions();

  const statText = lastUpdateTime > 0 ? `Updated ${moment.unix(lastUpdateTime).format('LLL')}` : t('Offline');
  const sensorCount = field && getFieldDevices(field) ? getFieldDevices(field).length : 0;

  return (
    <div ref={cardRef} style={{ width: '100%' }}>
      <Card className={selected ? classes.fieldSelected : classes.cardHover} onClick={() => selectField(field)}>
        <CardContent className={classes.cardContent}>
          <Typography variant="h4" className={classes.cardTitle}>
            {field?.name}
          </Typography>
          <Typography component="div" className={classes.cardCategory}>
            <div style={{ float: 'left' }}>
              {`${onlineSensors}/${sensorCount} ${t('probe', { count: sensorCount })} ${t('online')}`}
            </div>
          </Typography>
          <Typography component="div" className={classes.cardCategory}>
            <div style={{ float: 'left' }}>{`${t('area')}: ${field?.area} ${t('hectares')}`}</div>
          </Typography>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <div className={classes.cardStats}>
            <AccessTime className={`${classes.cardStatsIcon} ${classes[`${statIconColor}CardStatsIcon`]}`} /> {statText}
          </div>
        </CardActions>
      </Card>
    </div>
  );
};

FieldCard.propTypes = {
  getFieldDevices: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  statIconColor: PropTypes.oneOf(['warning', 'primary', 'danger', 'success', 'info', 'rose', 'gray']),
  onlineSensors: PropTypes.number.isRequired,
  lastUpdateTime: PropTypes.number.isRequired,
  selectField: PropTypes.func.isRequired,
  editField: PropTypes.func,
  selected: PropTypes.bool,
};

FieldCard.defaultProps = {
  statIconColor: 'gray',
  editField: () => {},
  selected: false,
};

export default FieldCard;
